import { types } from "../../reducers/types";
import axios from "axios";
import { store } from "../../App";
import { URL_COHORT } from "../../api/tklEnvironments";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import _ from "lodash";
import {
  prepareErrorMsg,
  showFirstValidationErrorFromAPI,
} from "../../components/utility/ReUsableFunctions";

export const getCatalogCourses = (
  stateSlug,
  purpose,
  isFeature,
  catalogOptionalValues,
  accountId, 
  micro,
  setCourseCatalogData,
  setFeatureCourseCatalogData,
  isMicroPage,
) => {
  return (dispatch) => {
    // let gradeLevelSlugsArr = (catalogOptionalValues?.gradelevelSlug || []).map(
    //   (item) => item.slug
    // );
    let pageType = isMicroPage ? "micro-course-program" : "kidvision";
    if (purpose) {
      let gradeLevelSlugsArr = "";
      (catalogOptionalValues?.gradelevelSlug || []).forEach((item, index) => {
        index === catalogOptionalValues?.gradelevelSlug?.length - 1
          ? (gradeLevelSlugsArr += item?.slug)
          : (gradeLevelSlugsArr += item?.slug + "&");
      });
      let contentAreaSlug = catalogOptionalValues?.["contentAreaSlug"]
        ? "&contentAreaSlug=" + catalogOptionalValues?.["contentAreaSlug"]
        : "";
      let gradelevelSlug = gradeLevelSlugsArr //catalogOptionalValues?.["gradelevelSlug"]
        ? `&gradelevelSlug[]=${gradeLevelSlugsArr}` //catalogOptionalValues?.["gradelevelSlug"]
        : "";
      let frameworkDomainSlug = catalogOptionalValues?.["frameworkDomainSlug"]
        ? "&frameworkDomainSlug=" +
          catalogOptionalValues?.["frameworkDomainSlug"]
        : "";

      // console.log(".....gradelevelSlug", gradelevelSlug, gradeLevelSlugsArr);
      axios
        .get(
          `${URL_COHORT}/get-catalogue-course?cohortPurposeSlug=${purpose}&isFeature=${isFeature}
          ${contentAreaSlug}${gradelevelSlug}${frameworkDomainSlug}${
            stateSlug ? `&stateSlug=${stateSlug}` : ""
          }`
        )
        .then(function (response) {
          if (response?.data) {
            if (response.data) {
              isFeature
                ? dispatch({
                    type: types.FEATURE_COURSE_CATALOG,
                    payload: response?.data?.response,
                  })
                : dispatch({
                    type: types.COURSE_CATALOG,
                    payload: response?.data?.response,
                  });
            }
          }
        })
        .catch(function (error) {
          console.error("..error", error);
        });
    }else if(micro){

      let gradeLevelSlugsArr = "";
      (catalogOptionalValues?.gradelevelSlug || []).forEach((item, index) => {
        index === catalogOptionalValues?.gradelevelSlug?.length - 1
          ? (gradeLevelSlugsArr += item?.slug)
          : (gradeLevelSlugsArr += item?.slug + "&");
      });
      let contentAreaSlug = catalogOptionalValues?.["contentAreaSlug"]
        ? "&contentAreaSlug=" + catalogOptionalValues?.["contentAreaSlug"]
        : "";
      let gradelevelSlug = gradeLevelSlugsArr //catalogOptionalValues?.["gradelevelSlug"]
        ? `&gradelevelSlug[]=${gradeLevelSlugsArr}` //catalogOptionalValues?.["gradelevelSlug"]
        : "";
      let frameworkDomainSlug = catalogOptionalValues?.["frameworkDomainSlug"]
        ? "&frameworkDomainSlug=" +
          catalogOptionalValues?.["frameworkDomainSlug"]
        : "";
      axios
        .get(
          `${URL_COHORT}/get-catalogue-course-program?cohortPurposeSlug=subscription-based-pd&isFeature=${isFeature}&accountId=${accountId}${contentAreaSlug}${gradelevelSlug}${frameworkDomainSlug}${isMicroPage ? `&programSlug=${pageType}` : ""}`
        )
        .then(function (response) {
          if(isFeature === 0){
            setCourseCatalogData(response?.data?.response) 
          }else if(isFeature === 1){
              setFeatureCourseCatalogData(response?.data?.response)
          }
        })
        .catch(function (error) {
          console.error("..error", error);
        });
    }
  };
};

export const getAccountCatalogCourses = (
  stateSlug,
  isFeature,
  accountId,
  catalogOptionalValues,
  type,
) => {
  let url;
  if(type){
    url = `get-catalogue-course-program?&cohortPurposeSlug=subscription-based-pd&programSlug=${type?.pageType}&`;
  }else{
    url = "get-account-catalogue-course?";
  }
  return (dispatch) => {
    let gradelevelSlug = catalogOptionalValues?.["gradelevelSlug"]
      ? "&gradelevelSlug=" + catalogOptionalValues?.["gradelevelSlug"]
      : "";
    let frameworkDomainSlug = catalogOptionalValues?.["frameworkDomainSlug"]
      ? "&frameworkDomainSlug=" + catalogOptionalValues?.["frameworkDomainSlug"]
      : "";
    let tagsArray = catalogOptionalValues?.["tags"];

    let tags = "";
    if (tagsArray?.length > 0) {
      tagsArray.forEach((tag) => {
        tags = tags + "&tagSlugs[]=" + tag;
      });
    }

    axios
      .get(
        `${URL_COHORT}/${url}stateSlug=${stateSlug}&isFeature=${isFeature}&accountId=${accountId}${gradelevelSlug}${frameworkDomainSlug}${tags}`
      )
      .then(function (response) {
        if (response?.data) {
          if (response.data) {
            isFeature
              ? dispatch({
                  type: types.FEATURE_COURSE_CATALOG,
                  payload: response?.data?.response,
                })
              : dispatch({
                  type: types.COURSE_CATALOG,
                  payload: response?.data?.response,
                });
          }
        }
      })
      .catch(function (error) {
        console.error("..error", error);
      });
  };
};

export const getPaymentIntent = (payload) => {
  // console.log("....payload", payload);
  return async (dispatch) => {
    return await axios
      .post(`${URL_COHORT}/place-order`, payload)
      .then(function (response) {
        if (response?.data) {
          dispatch({
            type: types.PAYMENT_INTENT,
            payload: response?.data?.response,
          });
          if (
            payload?.totalCartPrice === 0 &&
            !response?.data?.response?.paymentData &&
            response.status === 200
          ) {
            return Promise.resolve(true);
          } else if (response?.data?.response?.paymentData) {
            return Promise.resolve(false);
          } else {
            dispatch({
              type: types.API_ERROR,
              payload: `<p>Payment cannot be proceeded <strong><i>(Total cart value must be greater than 0)</i></strong>, Please try again<p>`,
              isRegisterPage: true,
            });
            return Promise.reject();
          }
        }
      })
      .catch(function (error) {
        if (error.response?.data?.errors) {
          let message = showFirstValidationErrorFromAPI(
            error.response?.data?.errors
          );
          dispatch({
            type: types.API_ERROR,
            payload: message,
          });
        }
        return Promise.reject();
      });
  };
};

export const confirmOrder = (orderID) => {
  return async (dispatch) => {
    axios
      .post(`${URL_COHORT}/confirm-order`, orderID)
      .then(function (response) {
        //console.log("response confirm-order: ", response);
        if (response?.data) {
          dispatch({
            type: types.CONFIRM_ORDER,
            payload: response?.data,
          });
        }
      })
      .catch(function (error) {
        console.error("..error", error);
        // if (error.response) {
        //   dispatch({
        //     type: types.API_ERROR,
        //     // payload: prepareErrorMsg(error.response),
        //   });
        // }
        if (error.response?.data?.errors) {
          let message = showFirstValidationErrorFromAPI(
            error.response?.data?.errors
          );
          dispatch({
            type: types.API_ERROR,
            payload: message,
          });
        }
      });
  };
};
export const addToCatalogCart = (
  cohortId,
  returnValueForExternalCart,
  donotShowPopup
) => {
  return async (dispatch) => {
    await axios
      .post(`${URL_COHORT}/add-cohort-to-cart`, cohortId)
      .then(function (response) {
        if (response?.data) {
          // if (!donotShowPopup) {
          //   dispatch({
          //     type: types.COMP_CART_API_SUCCESS,
          //     payload: "Added to Cart Successfully",
          //   });
          // }
          dispatch({
            type: types.CART_RELOAD,
            payload: true,
          });
        }
        if (returnValueForExternalCart) {
          return Promise.resolve();
        }
      })
      .catch(function (error) {
        console.error("..error", error);

        if (returnValueForExternalCart) {
          return Promise.reject();
        }
        if (error.response?.data?.errors) {
          let message = showFirstValidationErrorFromAPI(
            error.response?.data?.errors
          );
          dispatch({
            type: types.API_ERROR,
            payload: message,
          });
        }
      });
  };
};

export const addToCartExternal = (cohort) => {
  let cartItems = JSON.parse(localStorage.getItem("cartData") || "[]");

  return (dispatch) => {
    let newCardData = cartItems === "" ? [] : cartItems;
    console.log("....newCardData", newCardData);
    if (cohort) {
      Array.isArray(newCardData) && newCardData.push(cohort);
      localStorage.setItem("cartData", JSON.stringify(newCardData));
    }
    dispatch({
      type: types.GET_CART_DATA,
      payload: newCardData,
    });
  };
};

export const assignCourseGPLCMicro = (cohort, cohortGroups, cohortGroupId) => {
  let coursesData = JSON.parse(localStorage.getItem("assignedCourses") || "[]");

  return (dispatch) => {
    if (!_.isEmpty(cohort)) {
      let tempCourseData = coursesData === "" ? [] : coursesData;
      if (cohort) {
        tempCourseData.push(cohort);
        localStorage.setItem("assignedCourses", JSON.stringify(tempCourseData));
      }

      dispatch({
        type: types.GET_ASSIGNED_COURSES,
        payload: tempCourseData,
      });
    } else {
      let currentCohortGroup = cohortGroups.find(
        (obj) => obj?.slug === cohortGroupId
      );

      let tempCourseData = [];

      currentCohortGroup?.cohorts.forEach((cohortData) => {
        tempCourseData.push({ cohortId: cohortData?.cohortDisplayId });
      });

      localStorage.setItem("assignedCourses", JSON.stringify(tempCourseData));

      dispatch({
        type: types.GET_ASSIGNED_COURSES,
        payload: tempCourseData,
      });
    }
  };
};

export const removeCourseGPLCMicro = (cohort) => {
  let coursesData = JSON.parse(localStorage.getItem("assignedCourses") || "[]");

  return (dispatch) => {
    if (!_.isEmpty(cohort)) {
      let tempCourseData = coursesData === "" ? [] : coursesData;
      if (cohort) {
        tempCourseData = tempCourseData.filter(
          (obj) => obj?.cohortId !== cohort?.cohortId
        );
        localStorage.setItem("assignedCourses", JSON.stringify(tempCourseData));
      }

      dispatch({
        type: types.GET_ASSIGNED_COURSES,
        payload: tempCourseData,
      });
    }
  };
};
